import { useEventBus } from "@vueuse/core";

const notifyBus = useEventBus("notify");

export const notify = (options = {}) => {
  notifyBus.emit(options);
};
